import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage, t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  ];

  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    setIsOpen(false);
  };

  return (
    <div className="st-language-switcher" ref={dropdownRef}>
      <button
        className="st-language-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={t('language.selectLanguage')}
      >
        <span className="st-language-flag">{currentLang.flag}</span>
        <span className="st-language-name">{currentLang.name}</span>
        <span className={`st-language-arrow ${isOpen ? 'st-arrow-up' : 'st-arrow-down'}`}>
          ▼
        </span>
      </button>
      
      {isOpen && (
        <div className="st-language-dropdown">
          {languages.map((language) => (
            <button
              key={language.code}
              className={`st-language-option ${currentLanguage === language.code ? 'st-active' : ''}`}
              onClick={() => handleLanguageChange(language.code)}
            >
              <span className="st-language-flag">{language.flag}</span>
              <span className="st-language-name">{language.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
